export default "__VITE_ASSET__2710f399__"